import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GithubFacade } from '@mode/github/contract';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { GithubSyncDialogEffects } from './+state/github-sync-dialog/github-sync-dialog.effects';
import { GithubMenuEffects } from './+state/github.effects';
import { GithubFacadeService } from './+state/github.facade';
import * as fromGithub from './+state/github.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromGithub.GITHUB_FEATURE_KEY, fromGithub.githubReducer),
    EffectsModule.forFeature([GithubMenuEffects, GithubSyncDialogEffects]),
  ],
  providers: [{ provide: GithubFacade, useClass: GithubFacadeService }],
})
export class GithubDomainModule {}
